import axios from 'axios'
import BaseRequest from './BaseRequest'

export default class TimeRecommendRequest extends BaseRequest {
  getList() {
    return axios.get(`${this.baseUrl}/admin/recommends/timer/`)
  }

  getById(id) {
    return axios.get(`${this.baseUrl}/admin/recommends/timer/?id=${id}`)
  }

  insert(params) {
    return axios.post(`${this.baseUrl}/admin/recommends/timer/insert/`, params)
  }

  update(id, params) {
    return axios.post(
      `${this.baseUrl}/admin/recommends/timer/update/${id}`,
      params
    )
  }

  delete(id) {
    return axios.post(`${this.baseUrl}/admin/recommends/timer/delete/${id}`)
  }
}
